/*
Copyright 2022 by Herbert Potechius,
Ernst-Abbe-Hochschule Jena - University of Applied Sciences - Department of Electrical Engineering and Information
Technology - Immersive Media and AR/VR Research Group.
All rights reserved.
This file is released under the "MIT License Agreement".
Please see the LICENSE file that should have been included as part of this package.
*/


import React from 'react';
import './RightPanel.scss';
import Images from 'constants/Images';
import Texts from 'constants/Texts';
import Renderer from './Renderer';
import DownloadButton from "./DownloadButton"
import TextureButton from './TextureButton';
import WireframeButton from './WireframeButton';
import XrayButton from './XrayButton';
import DatasetButton from './DatasetButton'
import InfoButton from './InfoButton'
import MeshloadButton from './MeshloadButton';
import LightButton from './LightButton';
import LightmeshloadButton from './LightmeshloadButton';


function RightPanel(props){
  const panel_style = {
    width: window.innerWidth > 1200 ? window.innerWidth / 2 : window.innerWidth,
    left: window.innerWidth > 1200 ? window.innerWidth / 2 : "0px",
    height: window.innerHeight - 50
  }

  const body_style = {
    width: window.innerWidth > 1200 ? window.innerWidth / 2 - 250 : window.innerWidth,
    height: window.innerHeight - 150
  }

  const menu_style = {
    width: window.innerWidth > 1200 ? 250 : window.innerWidth,
    visibility: window.innerWidth > 1200 ? "visible" : "hidden",
    height: window.innerHeight - 150 - 1
  }

  const footer_style = {

  }

  return (
      // <div id="rightpanel_main" style={{width: "100vw", left: "0px"}}>
      <div id="rightpanel_main" style={panel_style}>
        <div id="rightpanel_header">no file loaded</div>
        <div id="rightpanel_footer">
          <WireframeButton/>
          <TextureButton/>
          <XrayButton/>
          {/* <LightButton/> */}
          <DatasetButton/>
          <InfoButton/>
        </div>
        <div id="rightpanel_body" style={body_style}>
          <div id="rightpanel_statusbar"></div>
          <Renderer id="rightpanel_renderer"/>
        </div>
        <div id="rightpanel_menu" style={menu_style}>
          {/* <DownloadButton>Download Object</DownloadButton>*/}
          <div id="rightpanel_buttonrow">
            <MeshloadButton className="meshloadbutton" pos="0" label="R" load="reflectance"/>
            <MeshloadButton className="meshloadbutton" pos="1" label="H" load="height"/>
            <MeshloadButton className="meshloadbutton" pos="2" label="N" load="normal"/>
            <MeshloadButton className="meshloadbutton" pos="3" label="M" load="mask"/>
            <MeshloadButton className="meshloadbutton" pos="4" label="T" load="texture"/>
            <MeshloadButton className="meshloadbutton" pos="5" label="S" load="shading"/>
          </div>
          <div id="rightpanel_lightrow">
            <LightmeshloadButton className="lightmeshloadbutton" pos="0" label="" color="#FFD700" load="0_07-00"/>
            <LightmeshloadButton className="lightmeshloadbutton" pos="1" label="" color="#FFD700" load="90_07-00"/>
            <LightmeshloadButton className="lightmeshloadbutton" pos="2" label="" color="#FF8C00" load="0_09-30"/>
            <LightmeshloadButton className="lightmeshloadbutton" pos="3" label="" color="#FF8C00" load="90_09-30"/>
            <LightmeshloadButton className="lightmeshloadbutton" pos="4" label="" color="#FF4500" load="0_12-00"/>
            <LightmeshloadButton className="lightmeshloadbutton" pos="5" label="" color="#1E90FF" load="0_14-30"/>
            <LightmeshloadButton className="lightmeshloadbutton" pos="6" label="" color="#1E90FF" load="90_14-30"/>
            <LightmeshloadButton className="lightmeshloadbutton" pos="7" label="" color="#8B4513" load="0_17-00"/>
            <LightmeshloadButton className="lightmeshloadbutton" pos="8" label="" color="#8B4513" load="90_17-00"/>
          </div>
          <div id="rightpanel_infobox"></div>
        </div>
      </div>
  );
  }

export default RightPanel;